import React from 'react';
import { Icon } from './Icons.styles';

export const ShareIcon = props => (
	<Icon
		viewBox="0 0 15 15"
		{...props}
		style={{ transform: 'translateX(-1px)' }}
	>
		<path
			fill="currentColor"
			fillRule="nonzero"
			d="M12.208 9.776c-.796 0-1.512.313-2.021.814L5.549 7.867c.02-.127.034-.257.034-.39 0-.13-.013-.257-.033-.381l4.63-2.693a2.873 2.873 0 0 0 2.028.821C13.75 5.224 15 4.054 15 2.612 15 1.17 13.75 0 12.208 0c-1.542 0-2.792 1.17-2.792 2.612 0 .13.014.256.033.381L4.82 5.685a2.873 2.873 0 0 0-2.028-.82C1.25 4.864 0 6.033 0 7.476s1.25 2.612 2.792 2.612c.796 0 1.512-.314 2.021-.814l4.638 2.723c-.02.127-.035.257-.035.39 0 1.443 1.25 2.612 2.792 2.612C13.75 15 15 13.831 15 12.388s-1.25-2.612-2.792-2.612z"
		/>
	</Icon>
);



// WEBPACK FOOTER //
// ./src/shared/icons/ShareIcon.js